import trottle from '../lib/throttle';
import $_GET from '../lib/$_GET';

export default class HTMLElement
{
	public currentStep: number;
	
	public stepMembersButton: HTMLButtonElement;
	public stepAccountButton: HTMLButtonElement;
	public stepPaymentButton: HTMLDivElement;
	
	public stepMembers: HTMLDivElement;
	public stepAccount: HTMLDivElement;
	public stepPayment: HTMLDivElement;
	
	public doneMembers: boolean;
	public doneAccount: boolean;
	
	public cardsButton: NodeList;
	
	public currentCard: HTMLDivElement;
	public changePlan: HTMLButtonElement;
	public oldPositionCard: any;
	
	public mainContainer: HTMLDivElement; //div.main
	
	public giftButton: HTMLButtonElement;
	public informationBlock: HTMLDivElement;
	
	//--------- forms
	public inputEmail: HTMLInputElement;
	public inputLogin: HTMLInputElement;
	public inputPass: HTMLInputElement;
	
	
	public joinButton: HTMLButtonElement;
	
	public constructor(  )
	{
		this.currentStep = 1;
		this.doneMembers = false;
		this.doneAccount = false;
		this.oldPositionCard = {};
		
		this.mainContainer = <HTMLDivElement>document.querySelector('div.main');
		
		this.stepMembersButton = <HTMLButtonElement>document.querySelector('div.step button.plan');
		this.stepAccountButton = <HTMLButtonElement>document.querySelector('div.step button.account');
		this.stepPaymentButton = <HTMLDivElement>document.querySelector('div.step.payment');
		
		this.cardsButton = <NodeList>this.mainContainer.querySelectorAll('.cards button.choice-plan');
		
		this.stepMembers = <HTMLDivElement>this.mainContainer.querySelector('div.cards');
		this.stepAccount = <HTMLDivElement>this.mainContainer.querySelector('div.account');
		this.stepPayment = <HTMLDivElement>this.mainContainer.querySelector('div.preload');
		
		this.currentCard = <HTMLDivElement>document.querySelector('div.account div.card');
		
		this.giftButton = <HTMLButtonElement>document.querySelector('button.gift-card');
		this.informationBlock = <HTMLDivElement>this.stepAccount.querySelector('div.information');
		
		this.stepMembersButton.addEventListener('click', this.changeBackPlan.bind(this) );
		this.stepAccountButton.addEventListener('click', this.stepAccountButtonHandlerClick.bind(this) );
		if ( this.giftButton )
		{
			this.giftButton.addEventListener('click', this.giftButtonHandlerClick.bind(this) );
		}
		
		
		Array.prototype.forEach.call(
			this.cardsButton,
			( item: HTMLButtonElement ) =>
			{
				item.addEventListener('click', this.changePlaneToAccount.bind(this) );
			}
		);
		
		this.setMainContainerHeight(this.stepMembers.offsetHeight);
		
		
		// -- form
		this.inputEmail = <HTMLInputElement>this.stepAccount.querySelector('#input-email');
		this.inputLogin = <HTMLInputElement>this.stepAccount.querySelector('#input-login');
		this.inputPass = <HTMLInputElement>this.stepAccount.querySelector('#input-password');
		
		this.joinButton = <HTMLButtonElement>this.stepAccount.querySelector('button.join');
		
		this.inputEmail.addEventListener('change', this.inputEmailCheckHandler.bind(this) );
		this.inputLogin.addEventListener('change', this.inputLoginCheckHandler.bind(this) );
		this.inputPass.addEventListener('change', this.inputPassCheckHandler.bind(this) );
		
		this.joinButton.addEventListener('click', this.joinButtonClickHandler.bind(this) );
		
		this.checkCountCards();
		
		window.addEventListener( 'resize', trottle(this.resizeWindow.bind(this)) );
		
		let _self:any = this;
		window.onpopstate = function(event) {
			if ( _self.currentStep == 2 ) _self.changeBackPlan();
		};
		
		this.checkOption();
		
		this.inputChecker();
	}
	private inputChecker():void
	{
		if ( this.inputEmail.value !== '' )
		{
			this.inputEmail.classList.add('done');
		}
		if ( this.inputLogin.value !== '' )
		{
			this.inputLogin.classList.add('done');
		}
		if ( this.inputPass.value !== '' )
		{
			this.inputPass.classList.add('done');
		}
	}
	
	/*private $_GET(key:string):any
	{
		let s:any = window.location.search;
		s = s.match(new RegExp(key + '=([^&=]+)'));
		return s ? s[1] : false;
	}*/
	private checkOption():void
	{
		if ( $_GET('option') )
		{
			let tempBtn: NodeList = <NodeList>this.mainContainer.querySelectorAll( 'div.cards button.choice-plan' );
			Array.prototype.forEach.call(
				tempBtn,
				(item: HTMLButtonElement) =>
				{
					if ( item.getAttribute('data-id') == <string>$_GET('option') )
					{
						item.click();
					}
				}
			);
		}
		else if ( localStorage.getItem("option") )
		{
			let errors: HTMLDivElement = <HTMLDivElement>document.querySelector( '.error' );
			let inputOption: HTMLInputElement = <HTMLInputElement>document.querySelector('#signup-option');
			
			if ( errors )
			{
				let tempBtn: NodeList = <NodeList>this.mainContainer.querySelectorAll( 'div.cards button.choice-plan' );
				
				Array.prototype.forEach.call(
					tempBtn,
					(item: HTMLButtonElement) =>
					{
						if ( item.getAttribute('data-id') == <string>localStorage.getItem("option") )
						{
							item.click();
							inputOption.value = item.getAttribute('data-id');
							//console.log('1',inputOption, inputOption.value);
						}
					}
				);
			}
			else
			{
				//let tempBtn: HTMLButtonElement = <HTMLButtonElement>this.mainContainer.querySelector( 'div.cards button.choice-plan[data-id="2000169"]' );
				//inputOption.value = "2000169";
				//tempBtn.click();
				//console.log('2',inputOption, inputOption.value);
			}
		}
		// Временное решение чтобы при открытии джоина юзер сразу видел годовой ценник. От 01/08/18
		else
		{
			//let inputOption: HTMLInputElement = <HTMLInputElement>document.querySelector('#signup-option');
			//let tempBtn: HTMLButtonElement = <HTMLButtonElement>this.mainContainer.querySelector( 'div.cards button.choice-plan[data-id="2000169"]' );
			//inputOption.value = "2000169";
			//tempBtn.click();
			//console.log('3',inputOption, inputOption.value);
		}
	}
	
	private resizeWindow(e: Event): void
	{
		switch (this.currentStep)
		{
			case 1:
			{
				this.setMainContainerHeight(this.stepMembers.offsetHeight);
				break;
			}
			case 2:
			{
				this.setMainContainerHeight(this.stepAccount.offsetHeight);
				break;
			}
		}
		
	}
	private checkCountCards(): void
	{
		let cards: NodeList = <NodeList>this.stepMembers.querySelectorAll('.card');
		
		if ( cards.length == 4 )
		{
			this.stepMembers.classList.add('four');
			this.stepAccount.classList.add('four');
		}
	}
	
	private inputCheckDone(input: HTMLInputElement):void
	{
		if ( input.value != '' )
		{
			input.classList.add('done');
		}
		else
		{
			input.classList.remove('done');
		}
	}
	public inputEmailCheckHandler(e?:KeyboardEvent):void
	{
		let input: HTMLInputElement = this.inputEmail;
		let error: HTMLDivElement = <HTMLDivElement>input.parentElement.querySelector('div.error');
		
		this.inputCheckDone(input);
		
		let regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
		let match: any;
		match = input.value.match(regex);
		
		if ( input.value != '' )
		{
			if ( !match )
			{
				if ( !error )
				{
					error = document.createElement('div');
					error.classList.add('error');
					error.innerHTML = 'Email error';
					
					input.parentElement.appendChild(error);
				}
				else
				{
					error.innerHTML = 'Email error';
				}
				
				input.parentElement.classList.add('error');
			}
			else if ( match )
			{
				if ( error )
				{
					error.parentElement.removeChild(error);
				}
				
				input.parentElement.classList.remove('error');
			}
		}
		else
		{
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = 'Email empty';
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = 'Email empty';
			}
			
			input.parentElement.classList.add('error');
		}
	}
	public inputLoginCheckHandler(e?:KeyboardEvent):void
	{
		let input: HTMLInputElement = this.inputLogin;
		let error: HTMLDivElement = <HTMLDivElement>input.parentElement.querySelector('div.error');
		let errorText: string = '';
		
		this.inputCheckDone(input);
		
		if ( input.value == '' )
		{
			errorText = 'Login empty';
			
			input.parentElement.classList.add('error');
			
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = errorText;
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = errorText;
			}
		}
		else if ( input.value.length < 6 )
		{
			errorText = 'Login to short';
			
			input.parentElement.classList.add('error');
			
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = errorText;
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = errorText;
			}
		}
		else if ( input.value.length > 16 )
		{
			errorText = 'Login to long';
			
			input.parentElement.classList.add('error');
			
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = errorText;
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = errorText;
			}
		}
		else
		{
			let regex = /^[A-Za-z0-9]{6,16}$/;
			let match: any;
			match = input.value.match(regex);
			
			if ( !match )
			{
				if ( !error )
				{
					error = document.createElement('div');
					error.classList.add('error');
					error.innerHTML = 'Login error';
					
					input.parentElement.appendChild(error);
				}
				else
				{
					error.innerHTML = 'Login error';
				}
				
				input.parentElement.classList.add('error');
			}
			else if ( match )
			{
				if ( error )
				{
					error.parentElement.removeChild(error);
				}
				
				input.parentElement.classList.remove('error');
			}
		}
	}
	public inputPassCheckHandler(e?:KeyboardEvent):void
	{
		let input: HTMLInputElement = this.inputPass;
		let error: HTMLDivElement = <HTMLDivElement>input.parentElement.querySelector('div.error');
		let errorText: string;
		
		this.inputCheckDone(input);
		
		let regex = /^[A-Za-z0-9_-]{6,25}$/;
		let match: any;
		match = input.value.match(regex);
		
		
		if ( input.value == '' )
		{
			errorText = 'Password empty';
			
			input.parentElement.classList.add('error');
			
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = errorText;
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = errorText;
			}
		}
		else if ( input.value.length < 6 )
		{
			errorText = 'Password to short';
			
			input.parentElement.classList.add('error');
			
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = errorText;
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = errorText;
			}
		}
		else if ( input.value.length > 16 )
		{
			errorText = 'Password to long';
			
			input.parentElement.classList.add('error');
			
			if ( !error )
			{
				error = document.createElement('div');
				error.classList.add('error');
				error.innerHTML = errorText;
				
				input.parentElement.appendChild(error);
			}
			else
			{
				error.innerHTML = errorText;
			}
		}
		else
		{
			if ( error )
			{
				error.parentElement.removeChild(error);
			}
			
			input.parentElement.classList.remove('error');
		}
	}
	
	public giftButtonHandlerClick(e: MouseEvent): void
	{
		//console.log(this.mainContainer.style.height);
		this.mainContainer.style.height = this.mainContainer.offsetHeight + 'px';
		//console.log(this.mainContainer.style.height);
	}
	public setMainContainerHeight(height: number): void
	{
		this.mainContainer.style.height = height + 20 + 'px';
	}
	public stepMembersButtonHandlerClick(e: MouseEvent): void
	{
		//console.log('stepMembersButtonHandlerClick');
	}
	public stepAccountButtonHandlerClick(e: MouseEvent): void
	{
		//console.log('stepAccountButtonHandlerClick');
	}
	
	private addOGOCoinButton( url: string ): void
	{
		let label: any;
		Array.prototype.forEach.call(
			document.querySelectorAll( 'fieldset.payment-type div' ),
			function ( div: HTMLDivElement )
			{
				label = div.querySelector('label');
				if ( label )
				{
					if ( label.innerHTML === 'Bitcoin' )
					{
						let newDiv = <HTMLDivElement>document.createElement('div');
						//let button:HTMLButtonElement = <HTMLButtonElement>document.createElement('button');
						
						newDiv.className = 'wrapper ogo';
						
						//button.type = 'button';
						//button.innerText = 'Pay with OGO Coin';
						//button.addEventListener( 'click', this.OGOCoinButtonHandlerClick.bind(this) );
						//newDiv.appendChild(button);
						newDiv.innerHTML = '<button type="button" onclick="location.href=\''+url+'\'">Pay with OGO Coin</button>';
						
						div.parentElement.appendChild(newDiv);
					}
				}
				
			}
		);
	}
	private ogoCoinCheck( button: HTMLButtonElement ): void
	{
		if ( button.hasAttribute('data-url') )
		{
			this.addOGOCoinButton( button.getAttribute('data-url') );
		}
	}
	public changePlaneToAccount(e: MouseEvent): void
	{
		// OGO coin
		this.ogoCoinCheck(<HTMLButtonElement>e.currentTarget);
		
		history.pushState({account:'acc'}, "Account information", "");
		
		localStorage.setItem('option',(<HTMLButtonElement>e.currentTarget).getAttribute('data-id') );
		
		this.currentCard.classList.remove('special');
		this.currentCard.classList.remove('trial');
		
		this.setMainContainerHeight(this.stepAccount.offsetHeight);
		
		let card = (<HTMLButtonElement>e.currentTarget).parentElement;
		this.doneMembers = true;
		this.currentStep = 2;
		
		card.classList.add('hide');
		
		let divTemp: HTMLDivElement = <HTMLDivElement>document.createElement('div');
		if ( card.classList.contains( 'trial' ) )
		{
			divTemp.classList.add('trial');
			
			this.currentCard.classList.add('trial');
		} else if ( card.classList.contains( 'special' ) )
		{
			divTemp.classList.add('special');
			divTemp.style.marginTop = '0';
			divTemp.classList.add('red-to');
			
			this.currentCard.classList.add('special');
		}
		
		divTemp.classList.add('temp-card');
		divTemp.innerHTML = card.innerHTML;
		divTemp.style.top = card.offsetTop+'px';
		divTemp.style.left = card.offsetLeft+'px';
		divTemp.style.width = card.offsetWidth+'px';
		divTemp.style.height = card.offsetHeight+'px';
		
		this.oldPositionCard = {
			top: card.offsetTop,
			left: card.offsetLeft,
			width: card.offsetWidth,
			height: card.offsetHeight
		};
		
		divTemp.classList.add('animate');
		
		this.stepAccount.appendChild(divTemp);
		
		this.currentCard.innerHTML = card.innerHTML;
		this.currentCard.style.width = card.offsetWidth+'px';
		this.currentCard.style.height = card.offsetHeight+'px';
		
		this.stepAccount.classList.add('current');
		this.stepMembers.classList.add('hide');
		this.informationBlock.classList.add('show');
		
		this.stepMembersButton.parentElement.classList.remove('current');
		this.stepMembersButton.parentElement.classList.add('done');
		this.stepAccountButton.parentElement.classList.add('current');
		
		
		divTemp.style.top = this.stepAccount.offsetTop+'px';
		divTemp.style.left = this.stepAccount.offsetLeft+'px';
		
		let _self = this;
		
		
		this.changePlan = <HTMLButtonElement>this.stepAccount.querySelector('button.choice-plan'); // кнопка смены плана на стр. акк инфо
		this.changePlan.addEventListener('click', this.changeBackPlan.bind(this) );
		
		// OGO coin
		let ogoPaymentType: HTMLDivElement = <HTMLDivElement>document.querySelector( '.information .payment-type div.ogo' );
		let ogoPaymentInfo: HTMLDivElement = <HTMLDivElement>document.querySelector( '.information>div.ogo-info' );
		let titleCard: HTMLHeadingElement = <HTMLHeadingElement>card.querySelector( 'h2' );
		let declineOGO: any = ['1 Month', '1 year', '3 months'];
		let checkerOgo: boolean = false;
		
		for ( let i: number = 0; i < declineOGO.length; i++ ){
			
			if ( titleCard.innerHTML.toLowerCase() === declineOGO[i].toLowerCase() ){
				checkerOgo = true;
			}
		}
		
		if ( checkerOgo === true){
			if ( ogoPaymentType !== null ){
				ogoPaymentType.classList.remove( 'hide' );
				ogoPaymentInfo.classList.remove( 'hide' );
			}
		} else {
			if ( ogoPaymentType !== null ){
				ogoPaymentType.classList.add( 'hide' );
				ogoPaymentInfo.classList.add( 'hide' );
			}
		}
		
		this.checkOGOPaymentType();
		
		setTimeout(
			function ( ) {
				let bTemp: HTMLButtonElement = <HTMLButtonElement>_self.stepAccount.querySelector('div.temp-card button.choice-plan');
				let b: HTMLButtonElement = <HTMLButtonElement>_self.currentCard.querySelector('button.choice-plan');
				_self.stepAccount.querySelector('div.temp-card').classList.add('to-black');
				
				bTemp.setAttribute('data-title', 'Change plan');
				b.setAttribute('data-title', 'Change plan');
			}, 300
		);
		setTimeout(
			function ( ) {
				_self.stepMembers.classList.remove('current');
				_self.stepMembers.classList.add('done');
				_self.stepAccount.classList.add('current');
				_self.informationBlock.classList.remove('show');
				_self.inputEmail.focus();
				
			}, 700
		);
		setTimeout(
			function ( ) {
				_self.stepAccount.querySelector('div.temp-card').remove();
				
			}, 900
		);
		
		// --- fix open gift card
		let giftBlock: HTMLDivElement = <HTMLDivElement>document.querySelector( 'div.gift-card' );
		
		if ( giftBlock )
		{
			if ( giftBlock.classList.contains( 'opened' ) )
			{
				giftBlock.classList.remove('opened');
				giftBlock.parentElement.parentElement.nextElementSibling.classList.remove('opened');
			}
		}
		
	}
	public checkOGOPaymentType():void{
		
		let otherLabel:NodeList = <NodeList>document.querySelectorAll( 'fieldset.payment-type div>input' );
		
		Array.prototype.forEach.call(
			otherLabel,
			(item: HTMLInputElement) => {
				if ( item.checked ){
					item.click();
				}
			}
		);
	}
	public changeBackPlan(e?:MouseEvent): void
	{
		if ( this.currentStep != 1 )
		{
			this.setMainContainerHeight(this.stepMembers.offsetHeight);
			// Need cover current card
			this.currentCard.classList.add('hide');
			
			this.doneMembers = false;
			this.currentStep = 1;
			
			let divTemp: HTMLDivElement = <HTMLDivElement>document.createElement('div');
			if ( this.currentCard.classList.contains( 'trial' ) )
			{
				divTemp.classList.add('trial');
				
				this.currentCard.classList.add('trial');
			} else if ( this.currentCard.classList.contains( 'special' ) )
			{
				divTemp.classList.add('special');
				divTemp.style.marginTop = '0';
				divTemp.classList.add('black-to');
				
				this.currentCard.classList.add('special');
			}
			
			divTemp.classList.add('temp-card');
			divTemp.classList.add('to-normal');
			
			divTemp.innerHTML = this.currentCard.innerHTML;
			divTemp.style.top = this.currentCard.offsetTop+'px';
			divTemp.style.left = this.currentCard.offsetLeft+'px';
			divTemp.style.width = this.currentCard.offsetWidth+'px';
			divTemp.style.height = this.currentCard.offsetHeight+'px';
			
			divTemp.classList.add('animate');
			this.stepAccount.appendChild(divTemp);
			
			//this.currentCard.innerHTML = this.currentCard.innerHTML;
			
			this.informationBlock.classList.add('hide');
			//
			//
			//
			
			this.stepMembersButton.parentElement.classList.add('current');
			this.stepMembersButton.parentElement.classList.remove('done');
			this.stepAccountButton.parentElement.classList.remove('current');
			
			//divTemp.style.top = this.oldPositionCard.top+'px';
			//divTemp.style.left = this.oldPositionCard.left+'px';
			
			let _self = this;
			
			if ( this.changePlan === null )
			{
				this.changePlan = <HTMLButtonElement>this.stepAccount.querySelector('button.choice-plan'); // кнопка смены плана на стр. акк инфо
				this.changePlan.addEventListener('click', this.changeBackPlan.bind(this) );
			}
			this.stepMembers.classList.remove('hide');
			this.stepMembers.classList.remove('done');
			this.stepMembers.classList.add('current');
			this.stepMembers.classList.add('show');
			
			//------ ogo coin
			let divWrapper = document.querySelector( 'div.wrapper.ogo' );
			
			if ( divWrapper !== null )
			{
				divWrapper.parentElement.removeChild(divWrapper);
			}
			
			setTimeout(
				function ( ) {
				(<HTMLDivElement>_self.stepAccount.querySelector('div.temp-card')).style.left = _self.oldPositionCard.left+'px';
				(<HTMLDivElement>_self.stepAccount.querySelector('div.temp-card')).style.top = _self.oldPositionCard.top+'px';
					_self.stepAccount.querySelector('div.temp-card').classList.add('to-red');
				}, 10
			);
			
			setTimeout(
				function ( ) {
					let bTemp: HTMLButtonElement = <HTMLButtonElement>_self.stepAccount.querySelector('div.temp-card button.choice-plan');
					let b: HTMLButtonElement = <HTMLButtonElement>_self.currentCard.querySelector('button.choice-plan');
					
					bTemp.setAttribute('data-title', 'Select plan');
					b.setAttribute('data-title', 'Select plan');
				}, 300
			);
			
			setTimeout(
				function ( ) {
					_self.stepMembers.querySelector('div.card.hide').classList.remove('hide');
					_self.stepAccount.querySelector('div.temp-card').remove();
					_self.currentCard.classList.remove('hide');
					
					_self.stepMembers.classList.remove('show');
					_self.stepAccount.classList.remove('current');
					_self.informationBlock.classList.remove('hide');
					
				}, 700
			);
		}
	}
	
	private joinButtonClickHandler(e: MouseEvent):void
	{
		if (
			( this.inputPass.value == '' ) ||
			( this.inputEmail.value == '' ) ||
			( this.inputLogin.value == '' )
		)
		{
			this.inputEmailCheckHandler();
			this.inputLoginCheckHandler();
			this.inputPassCheckHandler();
		}
		if ( this.checkForm() )
		{
			this.doneAccount = true;
			this.currentStep = 3;
			
			this.stepAccountButton.parentElement.classList.remove('current');
			this.stepAccountButton.parentElement.classList.add('done');
			this.stepPaymentButton.classList.add('current');
			
			//this.stepPayment.classList.add('current');
			//this.stepAccount.classList.add('done');
			//this.stepAccount.classList.add('hide');
			//this.stepAccount.classList.remove('current');
			//this.informationBlock.classList.add('hide');
			
			this.stepAccount.classList.add('step-3-wait');
		}
	}
	private checkForm():boolean
	{
		return (
			( !this.inputPass.parentElement.classList.contains('error') ) &&
			( !this.inputEmail.parentElement.classList.contains('error') ) &&
			( !this.inputLogin.parentElement.classList.contains('error') ) &&
			( this.inputPass.value != '' ) &&
			( this.inputEmail.value != '' ) &&
			( this.inputLogin.value != '' )
		);
	}
}
